import axios from "axios";
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] = "application/json";

// ? Send a Message
const sendEmail = async (message) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const messageStatus = await axios
    .post(`${apiUrl}/v1/public/contact`, message)
    .then((response) => {
      return response;
    });

  return messageStatus;
};
const createNewsletter = async (newsletter) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/crms?source=Contact us`, // Changed to "White paper"
    {
      email: newsletter.email,
      firstName: newsletter.firstName,
      lastName: newsletter.lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Page-Route': window.location.pathname,
        'X-Page-Title': document.title,
      },
    }
  );
  return response;
};

export default {
  sendEmail,
  createNewsletter  
};
